import { JobBlock as HygraphJobBlock } from '@/lib/types';

import SpecialtyJobBlocks from '@/features/specialty-page/components/specialty-job-blocks';
import jobBlocksTransformer from '@/hygraph/transformers/job-blocks.transformer';

export default function SpecialtyJobBlocksRenderer(props: HygraphJobBlock) {
  return <SpecialtyJobBlocks {...jobBlocksTransformer(props)} />;
}
